// extracted by mini-css-extract-plugin
export var heading = "index-module--heading--d985c";